import * as React from 'react';
import { render } from 'react-dom';
import App from './app/App';
import './config/I18nConfig'; //i18

// async/awaitを使用するために必要
import 'core-js/stable';
import { HelmetProvider } from 'react-helmet-async';
import 'regenerator-runtime/runtime';

const rootEl = document.getElementById('root');
render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
  rootEl
);
